import AbstractDeviceSetup from "../all/AbstractDeviceSetup";

class NagraDeviceSetup extends AbstractDeviceSetup {
  constructor() {
    super();
  }
}

export default NagraDeviceSetup;



// WEBPACK FOOTER //
// ./src/devices/nagra/DeviceSetup.js